/**
 * Very simple idle rotate thing
 * @param {object} pano
 * @param {number} maxT
 * @param {boolean} startIdleUntilInteraction
 */
export function init(pano,maxT=5000,startIdleUntilInteraction=false){

  let id = null
  const interactionEvents = ['click','touch']

  if (startIdleUntilInteraction){
    requestAnimationFrame(setForce)
    interactionEvents.forEach(e=>window.addEventListener(e,onInteraction))
  } else {
    setMoveEvents()
  }

  /**
   * First interaction if startIdleUntilInteraction
   */
  function onInteraction(){
    interactionEvents.forEach(e=>window.removeEventListener(e,onInteraction))
    onMove()
    setMoveEvents()
  }

  /**
   * Set the normal move events
   */
  function setMoveEvents(){
    ['mousemove','touchmove'].forEach(e=>window.addEventListener(e,onMove))
  }

  /**
   * Reset time when moving
   */
  function onMove(){
    id===null&&pano.call(getMoveForce())
    clearTimeout(id)
    id = setTimeout(setForce,maxT)
  }

  /**
   * Use the force
   */
  function setForce(){
    pano.call(getMoveForce(0.03))
    id = null
  }

  /**
   * Get the Krpano hlookat_moveforce command
   * @param {number} [force=0]
   * @return {string}
   */
  function getMoveForce(force=0){
    return `set(hlookat_moveforce,${force});`
  }
}



// WEBPACK FOOTER //
// ./src/js/pano/idle.js